import { useNavigate as useNavigateUmi, useSearchParams } from '@umijs/max';
import { useSessionStorageState } from 'ahooks';

// 这里做一层中转 来保存 面包屑
export const useNavigate = () => {
    const navigate = useNavigateUmi();
    const [mrcsBreadcrumbData, setmrcsBreadcrumbData] = useSessionStorageState('mrcs-breadcrumb-data', {
        defaultValue: {},
    });

    const proxuNavigate = (...params) => {
        // 暂存下 信息
        setmrcsBreadcrumbData({
            ...mrcsBreadcrumbData,
            [window.location.pathname]: {
                search: window.location.search,
                state: { ...window?.location?.state }
            }
        });

        navigate(...params)
    };

    return proxuNavigate;
};

